import {ORM, createReducer} from 'redux-orm';
import Users from './UsersModel';
import Locations from './LocationsModel';
import Circles from './CirclesModel';
import PendingUsers from './PendingUsersModel';



const orm = new ORM({
    stateSelector: state => state.orm,
});


orm.register(Users, Locations, Circles, PendingUsers);

const ormReducer = createReducer(orm);

export { orm, ormReducer };
export default orm;

